import GenericCanceled from "../GenericCanceledExitRequests/GenericCanceledExitRequests";
import { MY_EXIT_REQUESTS_REG, MY_EXIT_REQUESTS_EXPORT } from "@API/APIRoutes";

function MyCanceledExitRequestsListing() {
  return <GenericCanceled API={MY_EXIT_REQUESTS_REG} exportApi={MY_EXIT_REQUESTS_EXPORT} title={"My Canceled Exit Requests"}/>;
}

export default MyCanceledExitRequestsListing;
